import formPetsData from '../../ru/pets-form/pets-data.dic.json';

export const petsFormNS = {
  PETS_FORM_DATA: formPetsData,
};

export const petsNamespaces = ['PETS_FORM_DATA'];
